import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { GetGeneratedCompetitiveListExcelDownloadUrlQueryResponse, GetGeneratedCompetitiveListExcelDownloadUrlQueryParams } from "../../types/GetGeneratedCompetitiveListExcelDownloadUrl";

/**
     * @link /api/purchase-tenders/private/v1/tender/view_s3-competitive-list-download-url
     */
export async function getGeneratedCompetitiveListExcelDownloadUrl (params: GetGeneratedCompetitiveListExcelDownloadUrlQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<GetGeneratedCompetitiveListExcelDownloadUrlQueryResponse>["data"]> {
    const { data: resData } = await client<GetGeneratedCompetitiveListExcelDownloadUrlQueryResponse>({
        method: "get",
        url: `/api/purchase-tenders/private/v1/tender/view_s3-competitive-list-download-url`,
        params,
        ...options
    });
    
    return resData;
};